module.exports = __webpack_public_path__ + "img/temp_pub_2.23832275.jpg";